module.exports = __webpack_public_path__ + "static/img/gz_wx.9a26ebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gz_wx.jpg
// module id = JxBi
// module chunks = 0